<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            {{ title }}
        </div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'confirm-dialog'">
        <div class="confirm-message">{{ message }}</div>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-around">
        <button
            class="btn btn-sm primary-transparent"
            (click)="dialogRef.close(false)"
            [attr.data-testid]="'confirm-dialog-button-cancel'"
            mat-button
            type="button">
            {{ cancelText }}
        </button>
        <button
            class="btn btn-sm orange"
            (click)="dialogRef.close(true)"
            [attr.data-testid]="'confirm-dialog-button-ok'"
            mat-raised-button
            type="button">
            {{ okText }}
        </button>
    </div>
</mat-dialog-content>
